module.exports = __webpack_public_path__ + "static/media/icon-workpack-scheduled.145bf578.svg";